export default __webpack_public_path__ + "static/media/vivabonito9.f1bb6c02.jpg";